module.exports = __webpack_public_path__ + "img/weekly-1.5b686a64.png";